import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEducation = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.5001 13.0005V9.50047L20.5001 8.50047M4.50006 10.5005V15.9126C4.50006 16.6848 4.94465 17.3881 5.64226 17.7193L10.6423 20.0933C11.1851 20.351 11.8151 20.351 12.3579 20.0933L17.3579 17.7193C18.0555 17.3881 18.5001 16.6848 18.5001 15.9126V10.5005M2.57337 8.46381L11.2318 4.13463C11.4007 4.05018 11.5995 4.05018 11.7684 4.13463L20.4268 8.46381C20.869 8.68493 20.869 9.31601 20.4268 9.53713L11.7684 13.8663C11.5995 13.9508 11.4007 13.9508 11.2318 13.8663L2.57337 9.53713C2.13114 9.31601 2.13114 8.68493 2.57337 8.46381Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEducation;
